import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const SectionSummary = ({
  title,
  description,
  caption,
  children,
  srOnlyDescription,
  titleClassName,
}) => (
  <header className="section-summary">
    <div
      className="section-summary__left"
      aria-labelledby="section-title"
      aria-describedby={srOnlyDescription ? 'section-desc' : undefined}
    >
      <h3 className={cx('section-summary__title h3', titleClassName)} id="section-title">
        {title}
      </h3>
      {srOnlyDescription && (
        <p id="section-desc" className="visually-hidden">
          {srOnlyDescription}
        </p>
      )}
      {description && <p className="section-summary__description">{description}</p>}
      {caption && <p className="section-summary__caption">{caption}</p>}
    </div>
    <div className="section-summary__content">{children}</div>
  </header>
);

SectionSummary.propTypes = {
  title: T.node.isRequired,
  description: T.string,
  caption: T.string,
  children: T.node,
  srOnlyDescription: T.string,
  titleClassName: T.string,
};

export default SectionSummary;
